import {find, findFirst} from "@21torr/dune/dom/traverse.js";
import {isEmpty} from "../util/type-utils.js";
import {on} from "@21torr/dune/dom/events.js";
import {onLarge} from "../base/media-queries.js";

export function initFormStepDisplay(container) {

    let formSteps = find('.form-step', container);

    if (isEmpty(formSteps)) {
        return;
    }

    animateFormStepLabels(formSteps);

    on(window, "resize", animateFormStepLabels(formSteps));

}

function animateFormStepLabels(formSteps) {
    if (onLarge.matches()) {
        formSteps.forEach(formStep => {
            let formStepLabel = findFirst('.form-step-label', formStep);

            if (!isEmpty(formStepLabel)) {
                on(formStep, "mouseover", () => {
                    if (!formStepLabel.classList.contains('step-label-hover')) {
                        formStepLabel.classList.add('step-label-hover');

                        setTimeout(function () {
                            formStepLabel.classList.add('label-hover-start');
                        }, 100);

                    }
                });

                on(formStep, "mouseleave", () => {
                    if (formStepLabel.classList.contains('step-label-hover')) {
                        formStepLabel.classList.remove("label-hover-start")

                        setTimeout(function () {
                            formStepLabel.classList.remove('step-label-hover');
                        }, 450);
                    }
                });
            }
        });
    }
}